export default "__VITE_PUBLIC_ASSET__863b4853__"